import {
    DataGridPro,
    GridToolbarContainer,
    GridToolbarFilterButton,
    GridPinnedRowsProp, GridColDef, DataGridProProps, GridRowsProp, GridValidRowModel, GridPreProcessEditCellProps,
} from '@mui/x-data-grid-pro';
import { LicenseInfo } from '@mui/x-license';
import { ruRU } from '@mui/x-data-grid/locales';
import { GridCellEditCommitParams } from './XGridTableWrap';

/*
*   Таблица DataGridPro (XGrid)
*/

//TODO: Remove this component. Need keep only one Grid and onnly one license
LicenseInfo.setLicenseKey('4a9d79ec086e87806b702c7bc5c6e644Tz0xMTIyNDIsRT0xNzc3NTkzNTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMy0yMDI0LEtWPTI=');

type MuiTableProps = Omit<DataGridProProps, 'columns' | 'rows'>;

type TableProps = MuiTableProps & {
    onSelectionModelChange?: DataGridProProps['onRowSelectionModelChange'],
    selectionModel?: DataGridProProps['rowSelectionModel'],
    onCellEditCommit?: (params: GridCellEditCommitParams, editCellParams: GridPreProcessEditCellProps) => void,
}

type TableColumns = GridColDef & {
    hide?: boolean,
}

export type ReportGridProps<R extends GridValidRowModel> = {
    columns: TableColumns[],
    rows: GridRowsProp<R>,
    tableProps?: TableProps,
    pinnedRows?: GridPinnedRowsProp,
}

const CustomToolbarFilterButton = ({ disabled }: { disabled?: boolean }) =>
    <GridToolbarFilterButton
        slotProps={{
            button: { disabled },
        }}
    />

const CustomToolbar = ({ rows }: { rows: any }) =>
    <GridToolbarContainer sx={{ padding: '4px 5px' }}>
        <CustomToolbarFilterButton disabled={!rows?.length} />
    </GridToolbarContainer>

const transformTableProps = (columns: TableColumns[], tableProps?: MuiTableProps) => {

    const hiddenColumns: { [key: string]: boolean } = {};
    columns.forEach(column => {
        if (column?.hide) {
            hiddenColumns[column.field] = false
        }
    })

    return {
        ...tableProps,
        initialState: {
            ...tableProps?.initialState,
            columns: {
                columnVisibilityModel: { ...tableProps?.initialState?.columns?.columnVisibilityModel, ...hiddenColumns },
            },
        },
    }
}

export const ReportGrid = <R extends GridValidRowModel,>({
    columns,
    rows,
    tableProps,
    pinnedRows,
}: ReportGridProps<R>) => {

    const transformedTableProps = transformTableProps(columns, tableProps);

    return (
        <DataGridPro
            slots={{
                toolbar: () => <CustomToolbar rows={rows} />,
            }}
            columns={columns}
            rows={rows}
            pinnedRows={pinnedRows}
            disableColumnSelector
            disableRowSelectionOnClick
            disableColumnMenu
            hideFooter
            sx={{
                '& .MuiDataGrid-iconSeparator': {
                    display: 'none',
                },
                '.MuiDataGrid-columnSeparator': {
                    width: '0px',
                    height: '100%',
                    minHeight: '50px !important',
                    backgroundColor: '#E0E0E0',
                    borderLeft: '1px solid #F5F5F5',
                    borderRight: '1px solid #F5F5F5',
                    padding: '0px 0.5px',
                },
                '& .MuiDataGrid-columnHeader--filtered .MuiDataGrid-iconButtonContainer': {
                    display: 'none !important',
                },
                '& .MuiDataGrid-columnHeader:focus': {
                    outline: 'none',
                },
                '& .MuiDataGrid-columnHeader--alignRight': {
                    justifyContent: 'justify-content-end',
                    textAlign: 'right',
                },
                '& .MuiDataGrid-columnHeadersInner': {
                    alignItems: 'flex-start',
                },
                '& .MuiDataGrid-columnHeader': {
                    backgroundColor: 'rgba(250, 251, 251, 0.38)',
                },
                '& .MuiDataGrid-pinnedRows--bottom': {
                    background: 'rgb(25, 118, 210, 0.15)',
                },
                '& .MuiGrid-root': {
                    background: 'rgb(25, 118, 210, 0.15)',
                },
                '& .MuiDataGrid-columnHeaderTitleContainerContent > *': {
                    fontSize: '12px',
                    fontWeight: 700,
                    whiteSpace: 'break-spaces',
                    lineHeight: 1.3,
                    '> .MuiDataGrid-columnHeader--filtered': {
                        visibility: 'hidden !important',
                    },
                },
                '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#F5F5F5',
                    borderTop: transformedTableProps?.slots?.toolbar === null ? 'none' : '1px solid #E0E0E0',
                    borderTopLeftRadius: transformedTableProps?.slots?.toolbar === null ? '4px' : '0px',
                    borderTopRightRadius: transformedTableProps?.slots?.toolbar === null ? '4px' : '0px',
                },
                '& .MuiDataGrid-cell': {
                    fontWeight: 400,
                    paddingTop: '2px',
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 700,
                    whiteSpace: 'normal',
                    lineHeight: 1,
                },
                '& .MuiLink-root, .MuiGrid-item, .MuiTypography-root, .MuiButton-root, .MuiDataGrid-cell': {
                    fontSize: '12px',
                },
                '& .MuiDataGrid-cell:focus-within': {
                    outline: 'none',
                },
            }}

            {...transformedTableProps}


            localeText={
                {
                    ...(ruRU.components.MuiDataGrid.defaultProps.localeText),
                    noRowsLabel: 'Пусто',
                    ...(transformedTableProps?.localeText || {}),
                    filterOperatorDoesNotContain: 'не содержит',
                    filterOperatorDoesNotEqual: 'не равен',
                }
            }
        />
    );
}